export enum UserAPI {
 LOGIN = '/users/login',
 LOGOUT = '/users/logout',
 SIGNUP = '/users/signup',
 ACTIVATE = '/users/activate',
 CHECKSESSION = '/users/check-session'
}
